export default __webpack_public_path__ + "static/media/Inter-UI-BlackItalic.e972b518.woff";